import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloseXIcon } from 'assets/icons';
import { theme } from 'styles';
import { Icon, Text } from 'UI';
import {
  SDescription,
  SReasonButton,
  SCloseButton,
  SDarkPopupContainer,
  SReasonButtonsRow,
} from './CopyReferenceFeedback.styled';
import { CopyReferenceFeedbackReason } from './CopyReferenceFeedback.types';

interface WhySearchingElsewherePopupProps {
  onReasonClick: (reason: CopyReferenceFeedbackReason) => void;
  onClose: () => void;
}

export const WhySearchingElsewherePopup = ({ onReasonClick, onClose }: WhySearchingElsewherePopupProps) => {
  const { t } = useTranslation();

  return (
    <SDarkPopupContainer data-cy={'why-searching-elsewhere-popup'}>
      <SCloseButton
        onClick={onClose}
        data-cy={'close-why-searching-elsewhere'}
        aria-label={t('common.action.close', 'Close')}
      >
        <Icon IconComponent={CloseXIcon} width={20} height={20} color={theme.color.white} />
      </SCloseButton>
      <Text type="base" bold color="white" disableGutter>
        {t('catalog.copy_reference.why_searching_elsewhere.title', 'Why are you searching elsewhere?')}
      </Text>
      <SDescription>
        <Text type={'dark_14_medium_white_85'}>
          {t(
            'catalog.copy_reference.why_searching_elsewhere.description',
            // eslint-disable-next-line max-len
            'Everything you just searched is available here — genuine, in stock, delivered tomorrow. No need to look further.',
          )}
        </Text>
      </SDescription>
      <SReasonButtonsRow>
        <SReasonButton size="middle" onClick={() => onReasonClick('PRICE')} data-cy={'reason-price'}>
          {t('catalog.copy_reference.reason.price', 'Price')}
        </SReasonButton>
        <SReasonButton size="middle" onClick={() => onReasonClick('DELIVERY')} data-cy={'reason-delivery'}>
          {t('catalog.copy_reference.reason.delivery', 'Delivery')}
        </SReasonButton>
        <SReasonButton size="middle" onClick={() => onReasonClick('OTHER')} data-cy={'reason-other'}>
          {t('catalog.copy_reference.reason.other', 'Other')}
        </SReasonButton>
      </SReasonButtonsRow>
    </SDarkPopupContainer>
  );
};
